import { useEffect, useState } from "react";
import { useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { studentCertificatesManagement } from "../../../../hooks/api/StudentCertificatesManagement/StudentCertificatesManagement";
import { studentsManagement } from "../../../../hooks/api/StudentsManagement/StudentsManagement";
import { prepareSelect } from "../../../../services/core/Select";
import { DefaultLayout } from "../../../../layouts/Default";
import { TopNavigation } from "../../../../themes/Default/components/TopNavigation";
import { Button, ButtonBack } from "../../../../themes/Default/components/TopNavigation/components/Button";
import { Tabs } from "../../../../themes/Default/components/Tabs";
import { Main } from "../../../../themes/Default/components/Main";
import { Title } from "../../../../themes/Default/components/Title";
import { Breadcrumps } from "../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../themes/Default/components/Breadcrumps/components/Link";
import { Formik } from "formik";
import { Form } from "../../../../themes/Default/components/Form";
import { Row } from "../../../../themes/Default/components/Form/components/Row";
import { Field } from "../../../../themes/Default/components/Form/components/Row/components/Field";
import { Select } from "../../../../themes/Default/components/Form/components/Select";
import { List } from "../../../../themes/Default/components/List";
import { TableHead } from "../../../../themes/Default/components/List/components/Body/components/TableHead";
import { TableRow } from "../../../../themes/Default/components/List/components/Body/components/TableHead/components/TableRow";
import { TableHeadCell } from "../../../../themes/Default/components/List/components/Body/components/TableHead/components/TableRow/components/TableHeadCell";
import { TableBody } from "../../../../themes/Default/components/List/components/Body/components/TableBody";
import { TableDataCell } from "../../../../themes/Default/components/List/components/Body/components/TableBody/components/TableDataCell";
import { Header as ListHeader } from "../../../../themes/Default/components/List/components/Header";
import { Title as ListTitle } from "../../../../themes/Default/components/List/components/Header/components/Title";
import { Body as ListBody } from "../../../../themes/Default/components/List/components/Body";
import { useTranslation } from "react-i18next";
import { Slide, toast, ToastContainer } from "react-toastify";
import { Toaster } from "../../../../themes/Default/components/Toaster";

const StudentCertificates = () => {
    const { t } = useTranslation("common");
    const formRef = useRef(null);
    const navigate = useNavigate();
    const { studentId } = useParams();
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [certificates, setCertificates] = useState([]);
    const [attachedCertificates, setAttachedCertificates] = useState([]);
    const { 
        useStudentCertificateListMutation,
    } = studentCertificatesManagement;

    const { 
        useCertificatesListMutation,
        useAddCertificateMutation,
        useDeleteCertificateMutation,
        useViewStudentsMutation,
    } = studentsManagement;

    const [student] = useViewStudentsMutation()
    const [certificatesList] = useStudentCertificateListMutation();
    const [listStudentCertificates] = useCertificatesListMutation();
    const [addStudentCertificates] = useAddCertificateMutation();
    const [deleteStudentCertificates] = useDeleteCertificateMutation();

    const tabs = [
        { title: t("details"),  onClick: () => gotoDetailsTab(studentId) },
        // { title: t('students.tests'), onClick: () => gotoTestsTab(studentId)},
        { title: t("students.contract"), onClick: () => gotoContractsTab(studentId) },
        { title: t("calls.title"), onClick: () => gotoCallsTab(studentId) },
        { title: t('groups.title'), onClick: () => gotoGroupsTab(studentId)},
        { title: t('students.certificates'), isActive: true},
        { title: t("documents"),  onClick: () => gotoDocumentsTab(studentId) },
        { title: t("notes"),  onClick: () => gotoNotesTab(studentId) },
    ];

    const gotoContractsTab = (studentId) => {
        navigate("/students/" + studentId + "/contracts");
    };

    const gotoCallsTab = (studentId) => {
        navigate("/students/" + studentId + "/calls");
    };

    const gotoTestsTab = (studentId) => {
        navigate('/students/' + studentId + '/tests');
    }

    const gotoDetailsTab = (studentId) => {
        navigate("/students/edit/" + studentId);
    };

    const gotoNotesTab = (studentId) => {
        navigate("/students/" + studentId + "/notes");
    };

    const gotoDocumentsTab = (studentId) => {
        navigate("/students/" + studentId + "/documents");
    };

    const gotoGroupsTab = (studentId) => {
        navigate('/students/' + studentId + '/groups');
    }

    const onRemove = (certificateId) => {
        toast.warn(
            ({ closeToast }) => (
                <Toaster
                    closeToast={closeToast}
                    description={t("areYouSure")}
                    optionNo={t("no")}
                    optionYes={t("yes")}
                    onClick={() => {
                        closeToast();
                        deleteStudentCertificates({certificateId, studentId}).then((result) => {
                            if (result?.error) {
                                toast.error(result.error.data.error.responseMessage);
                            } else {
                                loadAttachedCertificates();
                                toast.info(result?.data?.info?.responseMessage);
                            }
                        })
                    }}
                />
            ),
            {
                autoClose: false,
                progress: false,
                closeButton: false,
            },
        );
    };

    const loadAttachedCertificates = () => {
        listStudentCertificates(studentId).then((result) => {
            setAttachedCertificates(result?.data?.records);
        });
    }

    const loadStudentName = () => {
        student(studentId).then((result) => {
            setFirstName(result?.data?.firstName);
            setLastName(result?.data?.lastName);
        });
    }

    useEffect(() => {
        certificatesList().then((result) => {
            let options = [];
            result?.data?.records.map((certificate) => {
                options.push(
                    {
                        id: certificate.id,
                        name: certificate.name
                    }
                );
            })
            setCertificates(prepareSelect(options));
        });
        loadAttachedCertificates();
        loadStudentName();
     }, []);

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to="/students" />
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Title>{firstName} {lastName}</Title>
                <Breadcrumps>
                    <Link title={t("students.title")} icon="fa-location-dot" />
                    <Link title={t("students.certificates")} />
                    <Link title={t("settings.list")} isActive={true}/>
                </Breadcrumps>
                <Formik
                    innerRef={formRef}
                    initialValues={{ 
                        certificates: "", 
                    }}
                >
                    {({ values, handleChange, setFieldValue, resetForm }) => (
                        <Form>
                            <Row>
                                <Field>
                                    <Select 
                                        name="certificates" 
                                        label={t("certificates.addNew")}
                                        options={certificates}  
                                        selectedValue={values.certificates}
                                        onChange={(event) => {
                                            const selectedCertificateId = event.target.value;

                                            if (attachedCertificates.some(c => String(c.id) === selectedCertificateId)) {
                                                return;
                                            }

                                            setFieldValue('certificates', selectedCertificateId);
                                            const body = { certificates: [selectedCertificateId] };
                                            addStudentCertificates({body, studentId}).then((result) => {
                                                if (result?.error) {
                                                    resetForm();
                                                    toast.error(result.error.data.error.responseMessage);
                                                } else {
                                                    resetForm();
                                                    loadAttachedCertificates();
                                                    toast.info(result?.data?.info?.responseMessage);
                                                }
                                            });
                                        }}
                                        searchInDropdown={false}
                                    />
                                </Field>
                                <Field></Field>
                            </Row>
                        </Form>
                    )}
                </Formik>
                <br />
                <List>
                    <ListHeader>
                    </ListHeader>
                    <ListBody>
                        <TableHead>
                            <TableRow>
                                <TableHeadCell></TableHeadCell>
                                <TableHeadCell><span>{t("certificates.name")}</span></TableHeadCell>
                                <TableHeadCell></TableHeadCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {attachedCertificates?.length > 0 &&
                            attachedCertificates?.map((attachedCertificate, index) => {
                                return (
                                    <TableRow key={index}>
                                        <TableDataCell></TableDataCell>
                                        <TableDataCell>{attachedCertificate.name}</TableDataCell>
                                        <TableDataCell>
                                            <Button icon="fa-solid fa-xmark" onClick={() => onRemove(attachedCertificate.id)}></Button>
                                        </TableDataCell>
                                    </TableRow>
                                )
                        })}
                        </TableBody>
                    </ListBody>
                </List>
            </Main>
        </DefaultLayout>
    );
};

export default StudentCertificates;